import React, { useState, useEffect } from 'react';
import NewExpense from './component/NewExpense/NewExpense'
import Expenses from './component/Expenses/Expenses';
import './App.css';
import logo from './images/anjani2.png';

function App() {
  const [response, setResponse] = useState([]);
  const [title, setTitle] = useState("");
  const [date, setDate] = useState("");
  const [amount, setAmount] = useState("");
  const [id, setId] = useState("");
  const [paymentAmount] = useState(1000); // Set the default payment amount
  const [orderId, setOrderId] = useState('');

  const deleteHandler = (title) => {
    fetch(`https://expense-backend-9gvx.onrender.com/delete/${title}`, {
      method: 'DELETE'
    }).then((result) => {
      result.json().then((res) => {

        const filteredArray = response.filter(item => item.title !== title)
        setResponse(filteredArray)
      })
    }).catch((error) => {
      console.log(error);
    });
  };

  const addExpenseHandler = async (expense) => {
    console.log('expense', expense);
    const myData = {
      title: expense.title,
      amount: expense.amount,
      date: expense.date.toISOString(),
    };
    try {
      const result = await fetch('https://expense-backend-9gvx.onrender.com/create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(myData)
      });

      const resultInJson = await result.json();
      setResponse(response => {
        if (response.length === 0) {
          return [resultInJson]; 
        } else {
          return [...response, resultInJson]; 
        }
      });

    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    try {
      const result = await fetch('https://expense-backend-9gvx.onrender.com/list')
      const jsonResult = await result.json()
      setResponse(jsonResult.data);
      setTitle(jsonResult.data[0].title)
      setDate(jsonResult.data[0].date)
      setAmount(jsonResult.data[0].amount)
      setId(jsonResult.data[0]._id)
    } catch (error) {
      console.log(error);
    }
  };
   const updateHandler = (data) => {
   
    setTitle(data.title)
    setDate(data.date)
    setAmount(data.amount)
    setId(data.id)
  }

 
  function updateUser() {
    let item = { title, date, amount };
    fetch(`https://expense-backend-9gvx.onrender.com/update/${id}`, {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(item)
    }).then((result) => {
      result.json().then((res) => {
        console.log(res);
        fetchData()

      })
    })
  }
  const createRazorpayOrder = async () => {
    try {
      const result = await fetch('https://expense-backend-9gvx.onrender.com/create-order', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ amount: paymentAmount }),
      });

      const resultInJson = await result.json();
      setOrderId(resultInJson.id);
    } catch (error) {
      console.log(error);
    }
  };
  // Load Razorpay script and create a new Razorpay instance
const loadRazorpay = (src) => {
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
};

const handlePayment = async () => {
  const res = await loadRazorpay('https://checkout.razorpay.com/v1/checkout.js');

  if (!res) {
    alert('Razorpay SDK failed to load. Are you online?');
    return;
  }

  const options = {
    key: 'rzp_test_bgNVcdw3ON8p2g',
    amount: paymentAmount * 100, // amount in the smallest currency unit
    currency: 'INR',
    order_id: orderId,
    name: 'Anjani Enterprises',
    description: 'Test Payment',
    image: logo,
    prefill: {
      name: 'Abhishek Mishra',
      email: 'Abhishekn@gmail.com',
      contact: '99999999990',
    },
    handler: function (response) {
      console.log(response);
      alert('Payment Successful');
    },
    modal: {
      ondismiss: function () {
        console.log('Transaction cancelled.');
      },
    },
  };

  const paymentObject = new window.Razorpay(options);
  paymentObject.open();
  };
  useEffect(() => {
    createRazorpayOrder(); // Automatically create Razorpay order on component mount
  }, []);
  return (
    <>
      <div>
        {response && <p>{response.message}</p>}
        <NewExpense onAddExpense={addExpenseHandler} />
        <Expenses items={response} onDeleteHandler={deleteHandler} onUpdateHandler={updateHandler} />
      </div>
      <div className="new-expense">
        <div className="new-expense__control" >
          <label>Title</label>
          <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} /> <br></br>
        </div>
        <div className="new-expense__control" >
          <label>Date</label>
          <input type='text' value={date} onChange={(e) => setDate(e.target.value)} /> <br></br>
        </div>
        <div className="new-expense__control" >
          <label>Amount</label>
          <input type='text' value={amount} onChange={(e) => setAmount(e.target.value)} /> <br></br>
        </div>
        <button onClick={updateUser} >Update User</button>
      </div>
      <div className="new-expense2">
        <button onClick={handlePayment}>Buy Premium</button>
      </div>
    </>
  );
};

export default App;
